import React, { FC } from "react";
import { Button } from "react-toolbox/lib/button";
import PageSelectorStyle from "./selectorStyle.scss";

interface PageButtonProps {
    readonly page: number;
    readonly current: boolean;
    onClick(page: number): void;
}

export const PageButton: FC<PageButtonProps> = props => {
    const { page, current } = props;

    function handleClick() {
        props.onClick(props.page);
    }

    return (
        <Button
            theme={PageSelectorStyle}
            onClick={handleClick}
            label={page.toString()}
            primary={current}
        />
    );
};
